module.exports = __webpack_public_path__ + "static/google_play_fr-93aaadabbf83aaa6456a00117db1b6cf.png";